namespace $.$$ {
	export class $shm_mentionstat_task extends $.$shm_mentionstat_task {
		@ $mol_mem
		form_query( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_excluded_words( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_date_from( next?: string ) {
			if( next !== undefined ) return next
			const now = new $mol_time_moment
			return now.shift({ year: -1, day: -now.day! }).toString( 'YYYY-MM-DD' )
		}

		@ $mol_mem
		form_date_to( next?: string ) {
			return next ?? new $mol_time_moment().toString( 'YYYY-MM-DD' )
		}

		@ $mol_mem
		form_country( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_language( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_search_type( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_tags( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_category( next?: string ) { return next ?? '' }

		@ $mol_mem
		form_social_files( next?: readonly File[] ) { return next ?? [] }

		@ $mol_mem
		form_mass_files( next?: readonly File[] ) { return next ?? [] }
	}
}
